module.exports = __webpack_public_path__ + "static/media/helexia_add_card_icon.32ddd0e6.svg";